import RenderedVideo from './RenderedVideo'

export default RenderedVideo
